import React, { useEffect, useState } from 'react'
import './styles.scss'
import { Scatter } from 'react-chartjs-2';
import { Chart as ChartJS, LinearScale, PointElement, LineElement, Tooltip, Legend, scales, elements } from 'chart.js';
import { decimalToFraction, processValue } from '../../../../shared/util/functions';
import { useSelector } from 'react-redux';
import { selectGtoState } from '../../../../stateManagement/redux';
import { validateAndFormatNumber } from '../../../../stateManagement/redux/slices/gerencia_tecnica/auxiliarFunctions';


// Register the necessary components with ChartJS
ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

const ReportCard = ({ activeActivityWithCard, activeFieldForActivities, activityValidation, targetRef, setSizeToGeneratePdf }: { activeActivityWithCard: any, activeFieldForActivities: string, activityValidation: any, targetRef: any, setSizeToGeneratePdf: boolean }) => {

    // const fields = ['Pozo','POT' ,'Sector', 'Estado Pozo Final', 'Unidad', 'Tiro', 'SPM', 'Carrera', 'THP','Carga_max','Carga_min', 'Maleza', 'Sonolog', 'Valvula 2da de 4', 'Frenos', 'Selector']
    const fields = [
        { "variableName": "Pozo", "showName": "Pozo" },
        { "variableName": "POT", "showName": "POT (BNPD)" },
        { "variableName": "Sector", "showName": "Sector" },
        { "variableName": "Estado Pozo Final", "showName": "Estado Pozo" },
        { "variableName": "Unidad", "showName": "Unidad" },
        { "variableName": "Tiro", "showName": "Tiro" },
        { "variableName": "SPM", "showName": "SPM" },
        { "variableName": "Carrera", "showName": "Carrera" },
        { "variableName": "THP", "showName": "THP" },
        { "variableName": "Carga_max", "showName": "Carga_max" },
        { "variableName": "Carga_min", "showName": "Carga_min" },
        { "variableName": "Maleza", "showName": "Maleza" },
        { "variableName": "Sonolog", "showName": "Sonolog" },
        { "variableName": "Valvula 2da de 4", "showName": "Valvula 2da de 4" },
        { "variableName": "Frenos", "showName": "Frenos" },
        { "variableName": "Selector", "showName": "Selector" }
    ]

    const [activityWithNewValues, setActivityWithNewValues] = useState(activeActivityWithCard)

    const mainState = useSelector(selectGtoState);

    const fields_in_blue = ['Pozo', 'Comentario']

    const [surfaceCard, setSurfaceCard] = useState<any>({ datasets: [{ label: "Carta de Superficie", showLine: true, borderColor: 'rgba(82, 137, 220, 1)', data: [], backgroundColor: ["rgba(82, 137, 220, 1)"] }] })
    const [bottomCard, setBottomCard] = useState<any>({ datasets: [{ label: "Carta de Fondo", showLine: true, borderColor: 'rgba(82, 137, 220, 1)', data: [], backgroundColor: ["rgba(82, 137, 220, 1)"] }] })


    useEffect(() => {

        const activityWithCardFixed = { ...activeActivityWithCard }

        const allLocations = mainState.locations

        const location = allLocations?.find(location => location.name === validateAndFormatNumber(activityWithCardFixed.Pozo, activeFieldForActivities))

        if (!activityWithCardFixed?.['Surface Card Position']) {


            try {
                let dynValue = JSON.parse(activityWithCardFixed?.['dynCarts'])
                if (dynValue?.length > 0) {
                    activityWithCardFixed['Fecha'] = activityWithCardFixed['Fecha'].split('T')[0]

                    const dynForActivity = dynValue[0]
                    activityWithCardFixed['Surface Card Position'] = dynForActivity['Surface Card Position'] || []
                    activityWithCardFixed['Surface Card Load'] = dynForActivity['Surface Card Load'] || []
                    activityWithCardFixed['Pump Card Position'] = dynForActivity['Pump Card Position'] || []
                    activityWithCardFixed['Pump Card Load'] = dynForActivity['Pump Card Load'] || []
                }
            } catch (error) {
                console.log({ error })
            }
        }

        const surfaceCardPoint = activityWithCardFixed?.['Surface Card Position']?.length || 0

        const bottomCardPoint = activityWithCardFixed?.['Pump Card Position']?.length || 0

        const dataSurface = []

        for (let index = 0; index < surfaceCardPoint; index++) {
            const position = activityWithCardFixed?.['Surface Card Position'][index];
            const load = activityWithCardFixed?.['Surface Card Load'][index];
            dataSurface.push({ x: position, y: load })
        }

        const dataBottom = []

        for (let index = 0; index < bottomCardPoint; index++) {
            const position = activityWithCardFixed?.['Pump Card Position'][index];
            const load = activityWithCardFixed?.['Pump Card Load'][index];
            dataBottom.push({ x: position, y: load })
        }

        setSurfaceCard({
            datasets: [{
                label: "Carta de Superficie",
                data: dataSurface, backgroundColor: ["rgba(82, 137, 220, 1)"],
                Animation: { duration: 0, enable: false },
                spanGaps: true,
            }],
            Animation: { duration: 0, enable: false },
        });

        setBottomCard({ 
            datasets: [{ 
                label: "Carta de Fondo", 
                data: dataBottom, backgroundColor: ["rgba(82, 137, 220, 1)"], 
                showLine: true, borderColor: 'rgba(82, 137, 220, 1)' ,
                Animation: { duration: 0, enable: false },
                spanGaps: true,
            }], 
            Animation: { duration: 0, enable: false } 
        });

        setActivityWithNewValues({
            ...activityWithCardFixed,
            'Unidad': `${activityWithCardFixed?.['Marca Balancin']}-${activityWithCardFixed?.['Modelo Balancin']}`,
            "Pozo": `${activeFieldForActivities} ${activityWithCardFixed?.['Pozo']}`,
            "Tiro": decimalToFraction(activityWithCardFixed?.['Tiro']),
            "SPM": processValue(activityWithCardFixed?.['SPM']),
            "Sector": location?.zone || activityWithCardFixed['Sector'],
            "POT": parseInt(location?.pot || activityWithCardFixed['POT']),
        })

    }, [activeActivityWithCard])

    const getValue = (field: string) => {

        const homologations: any[] = []

        activityValidation.forEach((v: any) => {
            if (v.homologation) {
                v.homologation.forEach((h: any) => {
                    homologations.push({ target: v.name, origin: h })
                })
            }
        })

        let value = activityWithNewValues?.[field]

        if (!value) {
            const newField = homologations.filter(h => h.target === field)
            for (const f of newField) {
                value = activityWithNewValues?.[f.origin];
                if (value) {
                    break;
                }
            }
        }

        return value
    }


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 0, enable: false },
        spanGaps: true,
        plugins: {
            legend: {
                position: 'top' as const,
                xlabels: "herre"
            },
            title: {
                // display: true,
                // text: 'Chart.js Scatter Chart'
            }
        },
        scales: {
            x: { beginAtZero: true },
            y: { beginAtZero: true }
        },
        elements: {
            point: {
                pointStyle: 'circle',
                radius: 0,
                // borderWidth:  4,
                borderColor: 'rgba(82, 137, 220, 1)',

            }
        }

    }

    return (
        // <div className='report_card_new' ref={targetRef} style={{ width: setSizeToGeneratePdf? '850px' :'98%', height: setSizeToGeneratePdf? '650px' :'98%', overflow: setSizeToGeneratePdf?'hidden':'none' }}>
        <div className='report_card_new' ref={targetRef} style={{ width: setSizeToGeneratePdf ? '850px' : '98%' }}>
            <div className='report_card_new_header'>
                {/* Logo */}
                <div className=''>
                    <img src="/assets/icons/logo_without_text.svg" alt='logo' height={60} width={60} />
                    <img src="/assets/icons/logo_text.svg" alt='logoText' height={60} width={150} />
                </div>
                {/* Dates And Enngineer */}
                <div className=''>
                    <div className='report_card_new_data_element_head'>
                        <div className='report_card_new_data_element_label'>Fecha :</div>
                        <div className='report_card_new_data_element_value'>{activityWithNewValues?.["Fecha"]}</div>
                    </div>
                    <div className='report_card_new_data_element_head'>
                        <div className='report_card_new_data_element_label'>Ingenieros :</div>
                        <div className='report_card_new_data_element_value'> {activityWithNewValues?.["Ingenieros"]}</div>
                    </div>
                </div>
            </div>
            <div className='report_card_new_body'>
                <div>
                    {fields.map((field, index) => (
                        <div className='report_card_new_data_element' key={index}>
                            <div className={`${fields_in_blue.includes(field.variableName) ? "report_card_new_data_element_label_blue" : "report_card_new_data_element_label"}`}>{field.showName}</div>
                            <div className='report_card_new_data_element_value'>{getValue(field.variableName)}</div>
                        </div>
                    ))}
                </div>
                <div className='report_card_new_cart_graph'>
                    <div>
                        <Scatter options={options} data={surfaceCard} redraw={false} />
                    </div>
                    <div>
                        {bottomCard?.datasets?.[0]?.data?.length > 0 && (
                            <Scatter options={options} data={bottomCard} redraw={false} />
                        )}
                    </div>
                </div>
            </div>
            <div>
                <div className='report_card_new_data_element_label_blue'>Cometario</div>
                <div className='report_card_new_data_element_value_comment'>{activityWithNewValues?.['Comentario']}</div>
            </div>
        </div>
    )
}

export default ReportCard

